import { useEffect, useState } from "react";
import cx from "classnames";
import Script from "next/script";
import { createPortal } from "react-dom";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    export interface IntrinsicElements {
      "jl-swatch-order": { "data-testid"?: string };
    }
  }
}

type Props = {
  isFullyOutOfStock: boolean;
  skuId: string;
  productId: string;
  scriptUrl?: string;
};

const SWATCH_DEFAULT_SCRIPT_URL = "/swatch-order-ui/static/js/swatch-order.js";

export const SwatchUI = ({
  isFullyOutOfStock,
  skuId,
  productId,
  scriptUrl,
}: Props) => {
  const [showPortal, setShowPortal] = useState(false);

  useEffect(() => {
    setShowPortal(true);
  }, []);

  return (
    <>
      <div
        data-testid="product:swatch"
        className={cx("swatch", {
          ["outOfStock"]: isFullyOutOfStock,
        })}
        data-component="Swatch"
      >
        <Script
          data-testid="product:swatch:script"
          src={scriptUrl ? scriptUrl : SWATCH_DEFAULT_SCRIPT_URL}
          type="application/javascript"
        />
        <div
          data-testid="product:swatch:option"
          className="web-component-wrapper swatch-product-wrapper"
          data-sku-id={skuId}
          data-product-id={productId}
        />
      </div>
      {showPortal &&
        createPortal(
          <jl-swatch-order data-testid="product:swatch:panel" />,
          document.body,
        )}
    </>
  );
};
